export const doShare = (data: any) => {
  window.wx.ready(function() {
    window.wx.updateAppMessageShareData({
      imgUrl: data.share_image ? data.share_image : window.shareObj.shareImgUrl,
      link: data.share_link ? data.share_link : window.shareObj.shareUrl,
      desc: data.share_sub_title,
      title: data.share_title,
      success: function() {},
      cancel: function() {}
    });
    window.wx.updateTimelineShareData({
      imgUrl: data.share_image ? data.share_image : window.shareObj.shareImgUrl,
      link: data.share_link ? data.share_link : window.shareObj.shareUrl,
      title: data.share_title,
      success: function() {},
      cancel: function() {}
    });
  });
};

export const doChangeTitle = (str: string) => {
  switch (str) {
    case "dnsb":
      return "东南商报";
    case "nbrb":
      return "宁波日报";
    case "xdjb":
      return "现代金报";
    default:
      return "宁波晚报";
  }
};
